import RefManager from "../RefManager";
import React, { createContext, ReactNode } from "react";

export const RefMonitorContext = createContext<RefManager | null>(null);

type RefMonitorProviderProps = {
  children: ReactNode;
  refManager: RefManager;
};

/**
 * Provides a shared RefManager instance to descendants via React context.
 */
const RefMonitorProvider = ({
  children,
  refManager,
}: RefMonitorProviderProps) => (
  <RefMonitorContext.Provider value={refManager}>
    {children}
  </RefMonitorContext.Provider>
);

export default RefMonitorProvider;
